export const bonuses = [
  {
    label: 'Bono 1',
    title: 'Planificador de los primeros 90 días',
    tagline: 'Organizá las fechas importantes sin olvidarte de nada.',
    body: 'Calendarios, registros de controles, vacunas, estudios, turnos y 13 planificadores semanales para completar.',
    highlight: 'Anotá → organizá → consultá',
    note: '',
  },
  {
    label: 'Bono 2',
    title: 'Guía rápida de señales de alerta',
    tagline: 'Reconocé cuándo es importante buscar atención médica.',
    body: 'Fichas visuales con señales de alerta del recién nacido y de la madre durante el posparto.',
    highlight: 'Observá → reconocé → consultá',
    note: 'Material orientativo. No reemplaza la atención médica.',
  },
  {
    label: 'Bono 3',
    title: 'Kit de checklists esenciales',
    tagline: 'Prepará todo sin hacer cada lista desde cero.',
    body: 'Listas para el bolso de maternidad, compras esenciales, higiene, documentación, regreso a casa y primeras salidas.',
    highlight: 'Revisá → prepará → marcá',
    note: '',
  },
  {
    label: 'Bono 4',
    title: 'Kit de organización y apoyo familiar',
    tagline: 'Organizá las responsabilidades y compartí las tareas.',
    body: 'Planificadores para distribuir tareas, organizar comidas, coordinar visitas y facilitar el apoyo familiar.',
    highlight: 'Compartí → organizá → acompañá',
    note: '',
  },
];
